import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

export const UPDATE_TIME = 200
export const MAX_PROGRESS = 90
export const PROGRESS_INCREASE = 10
export const ANIMATION_TIME = UPDATE_TIME * 2

const initialState = {
  percent: 0,
  progressInterval: null,
  animationTimeout: null,
  inAnimation: false,
  resetProgress: false
}

export class ProgressBar extends React.Component {
  constructor (props) {
    super(props)

    this.state = initialState

    this.boundSimulateProgress = this.simulateProgress.bind(this)
    this.boundResetProgress = this.resetProgress.bind(this)
  }

  componentWillMount () {
    if (this.props.loading > 0) {
      this.launch()
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.loading > this.props.loading) {
      this.launch()
    }
    if (nextProps.currentPath !== this.props.currentPath && this.state.inAnimation) {
      this.setState({resetProgress: true})
    }
  }

  componentWillUnmount () {
    clearInterval(this.state.progressInterval)
    clearTimeout(this.state.animationTimeout)
  }

  launch () {
    let { progressInterval, percent } = this.state
    const { animationTimeout } = this.state

    if (!progressInterval) {
      progressInterval = setInterval(
        this.boundSimulateProgress,
        this.props.updateTime
      )
      clearTimeout(animationTimeout)
      percent = 1
    }

    this.setState({ ...this.state, progressInterval, percent })
  }

  simulateProgress () {
    let { progressInterval, percent, animationTimeout, inAnimation, resetProgress } = this.state

    if (percent === 100) {
      clearInterval(progressInterval)
      animationTimeout = setTimeout(this.boundResetProgress, ANIMATION_TIME)
      progressInterval = null
      inAnimation = false
    } else if (this.props.loading === 0) {
      percent = 100
      inAnimation = false
    } else if (percent < this.props.maxProgress) {
      if (this.state.resetProgress) {
        if (percent > 1) {
          percent = 1
          inAnimation = false
        } else {
          inAnimation = true
          resetProgress = false
        }
      } else {
        percent = percent + this.props.progressIncrease
        inAnimation = true
      }
    }

    this.setState({ percent, progressInterval, animationTimeout, inAnimation, resetProgress })
  }

  resetProgress () {
    this.setState(initialState)
  }

  shouldShow (percent) {
    return (percent > 0) && (percent < 100) && !this.state.resetProgress
  }

  buildStyle () {
    const style = {
      width: `${this.state.percent}%`,
      transition: `width ${ANIMATION_TIME}ms ease-out,
                   height ${ANIMATION_TIME}ms linear,
                   opacity ${ANIMATION_TIME}ms ease-out`,
      opacity: '1',
      zIndex: 9999 // put at top
    }
    // https://mokapos.atlassian.net/browse/FD-1736
    if (!this.state.inAnimation) {
      style.transition = `height ${ANIMATION_TIME}ms linear,
                   opacity ${ANIMATION_TIME}ms ease-out`
    }
    // Use default styling if there's no CSS class applied
    if (!this.props.className) {
      style.height = '5px'
      style.backgroundColor = '#5599E7'
      style.position = 'fixed'
      style.top = 0
      style.left = 0
    }

    return { ...style, ...this.props.style }
  }

  render () {
    const style = this.buildStyle()
    if (this.shouldShow(this.state.percent)) {
      style.opacity = '1'
    } else {
      style.opacity = '0'
    }
    const ret = (
      <div>
        <div style={style} className={this.props.className} />
        <div style={{ display: 'table', clear: 'both' }} />
      </div>
    )
    return ret
  }
}

ProgressBar.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  actions: PropTypes.object,
  loading: PropTypes.number,
  updateTime: PropTypes.number,
  maxProgress: PropTypes.number,
  progressIncrease: PropTypes.number
}

ProgressBar.defaultProps = {
  style: {},
  className: undefined,
  loading: 0,
  updateTime: UPDATE_TIME,
  maxProgress: MAX_PROGRESS,
  progressIncrease: PROGRESS_INCREASE
}

const mapStateToProps = (state) => ({
  loading: state.notification.loadingBar
})

export default connect(mapStateToProps)(ProgressBar)



// WEBPACK FOOTER //
// app/javascript/components/frags/ProgressBar/ProgressBar.js